/**
 * schemesApi.js
 * -------------
 * API client for Schemes Master using createMasterApiClient.
 * Connects directly to FastAPI backend /schemes/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';
import { getCourseOptions as fetchCourses } from '../../courses/api/coursesApi';
import { getSubjectOptions as fetchSubjects } from '../../subjects/api/subjectsApi';

export const schemesClient = createMasterApiClient('schemes');

export async function listSchemes(params = {}) {
  return await schemesClient.list(params);
}

export async function getSchemeDetail(schemeId) {
  return await schemesClient.getById(schemeId);
}

export async function createScheme(payload) {
  return await schemesClient.create(payload);
}

export async function updateScheme(schemeId, payload) {
  return await schemesClient.update(schemeId, payload);
}

export async function archiveScheme(schemeId) {
  return await schemesClient.archive(schemeId);
}

export async function deleteScheme(schemeId) {
  return await schemesClient.remove(schemeId);
}

export async function getSchemeOptions() {
  return await schemesClient.getDropdownOptions();
}

export async function getCourseOptions() {
  try {
    const list = await fetchCourses();
    return (list || []).map((c) => ({
      value: String(c.id),
      label: c.name,
    }));
  } catch {
    return [];
  }
}

export async function getSubjectOptions() {
  try {
    const list = await fetchSubjects();
    return (list || []).map((s) => ({
      value: String(s.id),
      label: s.name,
    }));
  } catch {
    return [];
  }
}

export function getAcademicYears() {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = -1; i <= 3; i++) {
    const start = currentYear + i;
    const end = String(start + 1).slice(-2);
    const yr = `${start}-${end}`;
    years.push({ value: yr, label: yr });
  }
  return years;
}
